import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { trackSEOEvents, validateSchema } from "@/lib/seoAnalytics";

const TestimonialStructuredData = () => {
  const { t } = useTranslation(['testimonials']);
  
  const testimonials = Array.from({ length: 3 }, (_, i) => {
    const testimonial = t(`testimonials.${i}`, { returnObjects: true }) as any;
    return testimonial;
  }).filter(testimonial => testimonial?.quote);

  const reviewSchemas = testimonials.map(testimonial => ({
    "@context": "https://schema.org",
    "@type": "Review",
    "reviewBody": testimonial.quote,
    "author": {
      "@type": "Person",
      "name": testimonial.author
    },
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "itemReviewed": {
      "@type": "Service",
      "name": "Custom Price Calculators & Smart Forms",
      "provider": {
        "@type": "Organization",
        "name": "Daniel Gadus"
      }
    }
  }));
  
  useEffect(() => {
    try {
      reviewSchemas.forEach((schema) => {
        if (validateSchema(schema)) {
          trackSEOEvents.structuredDataLoaded('Review');
        }
      });
    } catch {}
  }, [testimonials]);
  
  return (
    <Helmet>
      {reviewSchemas.map((schema, index) => (
        <script key={index} type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      ))}
    </Helmet>
  );
};

export default TestimonialStructuredData;